export enum Url {
  // Auth routes
  Login = '/login',
  LoginSso = '/login/sso',
  LoginSuccess = '/login/success',
  AuthLanding = '/login/auth-landing',

  // Dashboard route
  Dashboard = '/dashboard',

  // Admin routes
  Admin = '/dashboard/admin',

  AdminManageEmployees = '/dashboard/admin/manage-employees',
  AdminEmployeeProfiles = '/dashboard/admin/manage-employees/employee-profiles',

  AdminEmployeeSettings = '/dashboard/admin/employee-settings',
  AdminApprenticeTrainingProgramSetup = '/dashboard/admin/employee-settings/apprentice-training-program-setup',
  AdminOtherDeductionsSetup = '/dashboard/admin/employee-settings/other-deductions-setup',
  AdminDemographicSetup = '/dashboard/admin/employee-settings/demographic-setup',

  // Contractor routes
  Contractor = '/dashboard/contractor',

  ContractorManageEmployees = '/dashboard/contractor/manage-employees',
  ContractorEmployeeProfiles = '/dashboard/contractor/manage-employees/employee-profiles',
  ContractorCopyEmployees = '/dashboard/contractor/manage-employees/copy-employees',
  ContractorMergeEmployees = '/dashboard/contractor/manage-employees/merge-employees',

  ContractorEmployeeSettings = '/dashboard/contractor/employee-settings',
  ContractorFringeBenefitsSetup = '/dashboard/contractor/employee-settings/fringe-benefits-setup',
  ContractorOtherDeductionsMatchSetup = '/dashboard/contractor/employee-settings/other-deduction-match-setup',
}
